import React, { useEffect } from 'react';
import { useAppDispatch } from '../../redux/store';
import { initializeAuth } from '../../redux/reducers/authInfoReducer';

export const AuthInitProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initializeAuth());
  }, []);

  return <>{children}</>;
};

export default AuthInitProvider;
